import * as React from 'react';
import { resolve } from 'inversify-react';
import { observable, computed } from 'mobx';
import { observer } from 'mobx-react';

import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';
import { DialogService } from 'src/core/services/ui/dialog.service';
import { CardController } from 'src/app/shared/card.controller';
import { TransportCompanyOfficeListView } from './office-list.view';
import { TransportCompanyOfficeListDataService } from './office.data';
import { ZuluIcon } from 'src/app/shared/icon';

interface TransportCompanyOfficeControllerProps {
	mode: ControlMode;
	onModeChanged: (mode: ControlMode) => void;
	goToCard: (text: any, key: string, model: Model, parentModel: Model) => void;
	setBusy(isBusy: boolean);
	model: SupplierItem;
	contextService: any;
	dataService: TransportCompanyOfficeListDataService;
}

@observer
export class TransportCompanyOfficeListController extends React.Component<TransportCompanyOfficeControllerProps, {}> {
	@resolve
	dialogService: DialogService;

	@resolve
	toast: ToastNotifications;

	constructor(props: Readonly<TransportCompanyOfficeControllerProps>) {
		super(props);
	}

	componentDidMount() {
		if (this.props.dataService != null && this.props.model && this.props.model.id > 0 && this.props.dataService.items.length == 0) {
			this.props.setBusy(true);

			this.loadData(this.props.model.id)
				.catch((error) => {
					this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
				})
				.then(() => {
					this.props.setBusy(false);
				});
		}
	}

	handleItemDoubleClick = async (item: TransportCompanyOfficeItem): Promise<void> => {
		const errors = await this.props.model.validate(false);
		if (errors.length == 0) {
			if (item == null) {
				this.props.dataService.create(() => this.props.dataService.add(this.props.model)).then(res => {
					res.entity.supplier = this.props.model.entity;
					let textView = <React.Fragment>
						<span>Office</span>
						<ZuluIcon type='close' />
						<br></br>
						<span>{res.title != '' ? res.title:"New"}</span>
					</React.Fragment>
					this.props.goToCard(textView, 'office', res, this.props.model);
				});
			}
			else {
				let textView = <React.Fragment>
					<span>Office</span>
					<ZuluIcon type='close' />
					<br></br>
					<span>{item.title}</span>
				</React.Fragment>
				this.props.goToCard(textView, 'office', item, this.props.model);
			}
		} else {
			this.toast.showToast('Validation error!', errors.map(e => e.text), 'error');
		}
	}

	private async loadData(supplierId: number): Promise<void> {
		if (this.props.model.id && this.props.dataService.items.length == 0) {
			if (this.props.model.type == 1) {
				this.props.dataService.addFilter('isDeleted', 'eq', false);
				this.props.dataService.addFilter('supplierId', 'eq', supplierId);
				this.props.dataService.addSorting('id', 'asc', true);
				this.props.dataService.pageSize = 20;
				await this.props.dataService.load(query => query);
			}
		}
	}

	render() {
		if (this.props.dataService == null || this.props.model == null) {
			return null;
		}

		return (
			<CardController
				icon="fa fa-map-marker"
				className="card-borderless"
				title="Office Information"
				mode={this.props.mode}>
				<TransportCompanyOfficeListView
					model={this.props.dataService}
					setBusy={this.props.setBusy}
					mode={this.props.mode}
					onModeChange={this.props.onModeChanged}
					onItemDoubleClicked={this.handleItemDoubleClick}
				/>
			</CardController>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/office/office-list.controller.tsx